import './_filter.scss';
import component from './filter';

export default component;
